import { render, staticRenderFns } from "./ConsentToInformalTrialKamloops.vue?vue&type=template&id=a4d098da"
import script from "./ConsentToInformalTrialKamloops.vue?vue&type=script&lang=ts"
export * from "./ConsentToInformalTrialKamloops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports